const translations = {
    ComingSoon: "In Kürze verfügbar",
    ContactUs: "Kontakt",
    FeatActivities: "E-Learning Aktivitäten",
    FeatActivities_sub:
        "Erstellen zuordnen und Feedback zu E-Learning-Aktivitäten geben.",
    FeatChat: "Blog und Chats zum Diskutieren und Teilen",
    FeatChat_sub:
        "Inhalte teilen und diskutieren mit der gesamten Klasse oder mit kleineren Gruppen.",
    FeatCoursePlanning: "Kursplanung und Kalender",
    FeatCoursePlanning_sub: "Vollständig anpassbarer Kursplaner.",
    FeatEvaluations: "Kursbewertungen",
    FeatEvaluations_sub:
        "Vollständig anpassbare Bewertungsformulare, die automatisch starten.",
    FeatLinksIntegration: "Integration von Links",
    FeatLinksIntegration_sub:
        "Genießen Sie schöne Integrationen für Videos, Website-Vorschauen, interaktive Formulare und vieles mehr.",
    FeatMultimediaComments: "Kommentare zu Bildern, Videos und Sounds",
    FeatMultimediaComments_sub:
        "Schreiben Sie Kommentare zu einer bestimmten Zeit oder an einem bestimmten Ort. Ideal für die Analyse.",
    FeatMultimediaDocs: "Multimediale Unterlagen",
    FeatMultimediaDocs_sub:
        "Laden Sie Bilder, Videos oder PDFs hoch, Isyflow verarbeitet sie und zeigt eine elegante Vorschau.",
    FeatNews: "News",
    FeatNews_sub:
        "Halten Sie Ihre Mitglieder einfach mit Neuigkeiten auf dem Laufenden.",
    FeatRegistration: "Kursanmeldungen",
    FeatRegistration_sub:
        "Lassen Sie die Studenten sich direkt zu den Kursen anmelden.",
    FeatSms: "Sms-Sendungen",
    FeatSms_sub:
        "Senden Sie automatische Erinnerungen oder benutzerdefinierte Nachrichten für unerwartete Ereignisse.",
    FeatTargetedCommunication: "Gezielte Kommunikation",
    FeatTargetedCommunication_sub:
        "Senden Sie Nachrichten an alle Lehrer oder alle Schüler, die in einem Semester eingeschrieben sind.",
    FeatTeacherWorkspace: "Kurs-Homepage",
    FeatTeacherWorkspace_sub:
        "Erstellen Sie Arbeitsräume und laden Sie Ihre Schüler ein.",
    Impressum: "Impressum",
    InfoPrivateRollout:
        "Isyflow wird seit 5 Jahren erfolgreich an schweizerischen und deutschen Bildungsinstitutionen und Universitäten eingesetzt. Die Plattform wird in Kürze für die individuelle Nutzung zur Verfügung stehen.",
    Login: "Login",
    LoginOrSignup: "Login / Registrieren",
    Nav_Home: "Home",
    Nav_Vet: "Isyflow-VET",
    Nav_Learning: "Isyflow-Learning",
    OpenAccountTrial: "Konto eröffnen (Gratis bis 31.08.2020)",
    OrganisationFeaturesTitle: "Für Institutionen",
    Plan_Free: "FREE",
    Plan_Guru: "GURU",
    Plan_Organisation: "Organisation",
    Plan_Pro: "PRO",
    Pricing_encoding: "{count} Minuten Video- und Ton-Upload pro Monat",
    Pricing_featuresTeacher: "Lehrperson-Features",
    Pricing_featuresMiniOrg: "Homepage + Arbeitsraumhierarchie",
    Pricing_featuresOrg: "Institutionen-Features (in Option)",
    Pricing_from: "ab",
    Pricing_members: "{count} Mitglieder enthalten",
    Pricing_membersAdd: "2.-/Mitglied/Monat",
    Pricing_membersUnlimited: "Unbegrenzte Mitgliederzahl",
    Pricing_perMonth: "pro Monat",
    Pricing_perMonthAltern: "oder {price}.- pro Monat",
    Pricing_perYear: "pro Jahr",
    Pricing_storage: "{count} GB Speicher",
    Pricing_storageAdd: "1.-/Monat pro 10GB",
    Pricing_emailSupport: "E-Mail-Support",
    Pricing_emailSupportPriority: "Prioritärer E-Mail-Support",
    Pricing_emailAndPhoneSupportPriority:
        "Prioritärer E-Mail- und Telefonsupport",
    Pricing_workspace: "{count} Arbeitsraum",
    Pricing_workspaces: "{count} Arbeitsräume",
    Pricing_workspacesUnlimited: "Unbegrenzte Arbeitsräume",
    PricingTitle: "Preise",
    PrivacyPolicy: "Datenschutzerklärung",
    PricingWarning:
        "Individual plans are still in a private testing phase and will be available soon. Please contact us if you are interested in participating to the test phase or would like to be informed when these plans become available.",
    Product_Learning: "Isyflow Learning",
    Product_Learning_Desc:
        "Digitales Cockpit für Lehrpersonen und Institutionen",
    Product_Vet: "Isyflow VET",
    Product_Vet_Desc: "Digitales Cockpit für die Berufsbildung",
    Products: "Produkte",
    TeacherFeaturesTitle: "Für Lehrpersonen",
    Team_Dev: "Entwicklung",
    Team_Consulting: "Consulting",
    Tutorials: "Tutorials",
    VetFeatures: "Umfangreiche Funktionen für jeden Stakeholder",
    Vet_Admin: "Kursverwaltung",
    Vet_AdminDesc:
        "Verbände, Betriebe und Schulen publizieren Kurse, erhalten Anmeldungen, sehen die Teilnehmerliste, lösen Rechnungen aus, wickeln den Präsenz- oder Onlinekurs in Isyflow ab und verschicken automatisch Teilnahmebestätigungen. Sie produzieren multimediale und interaktive E-learning Einheiten in Isyflow und stellen sie frei oder gegen Gebühr zur Verfügung.",
    Vet_LearnPlan: "Bildungspläne und digitalen Formulare",
    Vet_LearnPlanDesc:
        "Verbände und Oda’s stellen in Isyflow ihre Bildungspläne und alle digitalen Formulare für Lerndokumentationen, Evaluationen und Semesterberichte in einer App zur Verfügung. Sie können News und  regelmässige und automatisierte Erinnerungen versenden, Abschlussprüfungen organisieren und ihre Bewertungen verwalten.",
    Vet_SiteCoop: "Lernortkooperation",
    Vet_SiteCoopDesc:
        "Schulen und ÜK können Praxisbeispiele im Unterricht verwenden, welche die Lernenden nach Rücksprache freigegeben haben. Sie erfahren, welche Lernenden in ihren Betrieben ähnliches getan oder nicht getan haben und können diese Gruppen in Kursen differenzieren und so die betriebliche Ausbildung gezielt ergänzen. Schulen und Üks können behandelten und geprüften Lernziele für die Betriebe sichtbar einzutragen.",
    Vet_Situated: "Situierte Ausbildungsunterlagen",
    Vet_SituatedDesc:
        "Schulen und überbetriebliche Kurse ordnen Ausbildungsunterlagen den Situationen zu. Berufsbilderinnen verlinken bei Bedarf ihren Lernenden diese Übungen und Lernmaterialien und erhalten eine Nachricht, wenn sie durchgearbeitet wurden.",
    Vet_Skills: "Kompetenzen und Situationen",
    Vet_SkillsDesc:
        "Die BerufsbilderInnen erhalten eine Nachricht, wenn ein Feedback zu einer Evaluation oder einer Lerndokumentation nötig ist. Die dokumentierten Arbeitssituationen der Lernenden werden mit den Kompetenzen oder Situationen der Bildungspläne verbunden. So entsteht ein übersichtliches Bild des Fortschritts. Zudem wird die Persönlichkeitsentwicklung (Arbeitsorganisation, Flexibilität etc.) erfasst und im Zeitverlauf diskutierbar.",
    VetFeat_Oda: "Verband, OdA",
    VetFeat_Oda_0: "Erfasst Bildungspläne",
    VetFeat_Oda_1:
        "Stellt Formulare für Evaluationen, Lerndokumentation, Semesterberichte zur Verfügung",
    VetFeat_Oda_2:
        "Organisiert Weiterbildungen und Kurse: Ausschreibung, Anmeldung, Teilnehmerliste, Unterlagen etc.",
    VetFeat_Oda_3:
        "Erstellt E-Learning-Einheiten: multimedial und interaktiv, mit eingebundenen Simulationen",
    VetFeat_Oda_4: "Stellt Ausbildungsunterlagen druckfertig bereit",
    VetFeat_Oda_5: "Organisiert Prüfungen und verwaltet Bewertungen",
    VetFeat_Comp: "Betrieb und SupervisorInnen",
    VetFeat_Comp_0:
        "Automatisieren administrative Prozesse und nutzen die Plattform für eigene Unterlagen",
    VetFeat_Comp_1:
        "Erhalten ein Cockpit mit Ausbildungsstand und Persönlichkeitsentwicklung alle Lernenden",
    VetFeat_Comp_2:
        "Füllen Lerndokumentation, Evaluation, Semesterbericht online aus",
    VetFeat_Comp_3:
        "Erhalten Benachrichtigung, wenn ein Feedback erforderlich ist",
    VetFeat_Comp_4:
        "Legen eigene  Unterlagen wie Instruktionen, Prozesse, Produktinformationen ab",
    VetFeat_Comp_5: "Senden News an alle Lernenden oder AusbilderInnen",
    VetFeat_School: "Schule und überbetriebliche Kurse",
    VetFeat_School_0:
        "Erhalten eine Verbindung mit Betrieben oder Nutzen Isyflow als Ausbildungsplattform",
    VetFeat_School_1:
        "Erfassen behandelte Lernziele  zur Information der Praxis",
    VetFeat_School_2: "Stellen der Praxis Unterlagen und Übungen bereit",
    VetFeat_School_3: "Erhalten Beispiele aus der Praxis",
    VetFeat_Stud: "Lernende",
    VetFeat_Stud_0:
        "Dokumentieren via Smartphone, haben Zugang zu personalisierten Übungen; erhalten Erinnerung an Aufgaben und Termine",
    VetFeat_Stud_1:
        "Bearbeiten digitale Berichte und Evaluationsformulare, erhalten Feedback",
    VetFeat_Stud_2: "Nutzen geschützten Chat mit Ausbildern",
    VetFeat_Stud_3:
        "Sehen Ausbildungsfortschritt und Persönlichkeitsentwicklung",
    VetFeat_Stud_4: "Stellen Praxisbeispiele für ÜK und Schule bereit",
    VetFeat_Stud_5: "Erhalten ein Kompetenzprofil für Bewerbungen",
    VetFeat_Stud_6:
        "Erfassen Weiterbildungen und erhalten Weiterbildungsangebote",
    VetFeat_Admin: "Verwaltung (*)",
    VetFeat_Admin_0: "Sendet Newsletter an Lernende, Schulen, Betriebe",
    VetFeat_Admin_1: "Erfasst Bildungspläne",
    VetFeat_Admin_2:
        "Erstellt Arbeits/Lernräume und Chats für Projektgruppen und Kursen",
    VetFeat_Admin_3: "Zieht in funktionalen Cockpits Informationen zusammen",
    VetFeat_Admin_4:
        "Erstellt Formulare für Lerndokumentation, Semesterberichte, Evaluationen und zum Erfassen der Pesönlichkeitsentwicklung",
    VetFeat_Admin_5:
        "Speichert Ausbildungsunterlagen  und ordnet sie Ausbildungszielen und - Situationen zu",
    VetFeat_Admin_6: "Erstellt E-Learning Einheiten (*)",
    VetFeat_Admin_7:
        "Erstellt Kurse inkl. Anmeldung, Durchführung, Rechnungsstellung (*)",
    VetFeat_Admin_8:
        "Veranlasst Single Sign On und Integration in vorhandene Schulplattformen wie Microsoft Teams oder Moodle (*)",
    VetPrice_1: "40.- pro Lernende für die ganze Ausbildung ",
    VetPrice_1_1:
        "Ab 250 bis 2000 neue Lehrverträge pro Jahr, danach Staffelpreise",
    VetPrice_2: "28.- für die Nutzung nach der Ausbildung",
    VetPrice_2_1:
        "Als lebenslange Lerndokumentation, Erfahrungs- und Weiterbildungsnachweis",
    VetPrice_3: "10.- Zusätzlich für (*) Funktionen.",
    WelcomeTitle: "Die Lernplattform für das digitale Zeitalter.",
    WelcomeSubtitle:
        "Isyflow ist eine Online-Plattform, die innovativen Lehrpersonen und Ausbildungsinstitutionen einfach zu bedienende und dennoch effektive Kommunikations-, Kooperations- und Managementwerkzeuge bietet."
};

export default translations;
